import { notEmpty } from '@festina-life/core'

import { IconButton } from '../../../actions/iconButton/IconButton'
import { DoubleInput } from '../../../forms/doubleInput/DoubleInput'
import { useTranslate } from '../../../hooks/useTranslate'
import { Dropdown } from '../../../structure/dropdown/Dropdown'
import type { ColumnFilterState } from '../useFilterState'

type State<T> = ColumnFilterState<T> & { type: 'numberRange' }

type Props<T> = {
  state: State<T>
  onStateChanged: (state: State<T>) => void
}

export const NumberRangeFilter = <T,>({ state, onStateChanged }: Props<T>) => {
  const translate = useTranslate()

  return (
    <Dropdown
      element={
        <IconButton
          iconName="Filter"
          isSelected={notEmpty(state.min || state.max)}
          className="-m-1"
        />
      }
      items={[
        {
          element: (
            <DoubleInput
              wrapperProps={{
                label: translate('table.filter.minTitle'),
                className: 'py-0!',
              }}
              value={state.min}
              onChange={(min) => onStateChanged({ ...state, min: min || null })}
            />
          ),
        },
        {
          element: (
            <DoubleInput
              wrapperProps={{
                label: translate('table.filter.maxTitle'),
                className: 'py-0!',
              }}
              value={state.max}
              onChange={(max) => onStateChanged({ ...state, max: max || null })}
            />
          ),
        },
      ]}
    />
  )
}
